import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyB5HRjoTO1mcoDHM9CDk_hbZCBW0hhgjxo",
    authDomain: "linkcast-e3ea3.firebaseapp.com",
    databaseURL: "https://linkcast-e3ea3-default-rtdb.firebaseio.com",
    projectId: "linkcast-e3ea3",
    storageBucket: "linkcast-e3ea3.appspot.com",
    messagingSenderId: "1062354966616",
    appId: "1:1062354966616:web:a71cc02ad6f8f9ecbc122d"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const database = getDatabase(app);

export { auth, database };
